import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import Modal from '../../../components/Modal';

const DeleteDocumentModal = ({ isOpen, onClose, onConfirm, document, loading }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Document"
      size="sm"
      footer={
        <div className="w-full flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-5 py-2 rounded-lg text-sm font-medium text-slate-600 border border-slate-200 hover:bg-slate-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="px-5 py-2 rounded-lg text-sm font-medium text-white bg-red-500 hover:bg-red-600 transition-colors disabled:opacity-50"
          >
            {loading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      }
    >
      <div className="flex flex-col items-center text-center gap-4 py-4">
        <div className="w-14 h-14 rounded-full bg-red-100 flex items-center justify-center">
          <FiAlertTriangle className="text-red-500 text-2xl" />
        </div>
        <div>
          <p className="text-slate-700 font-medium text-base">
            Are you sure you want to delete this document?
          </p>
          {document?.documentName && (
            <p className="mt-1 text-sm text-slate-500">
              <span className="font-semibold text-slate-700">{document.documentName}</span>
              {document.organizationName && (
                <span> shared with <span className="font-semibold text-slate-700">{document.organizationName}</span></span>
              )}
            </p>
          )}
          <p className="mt-3 text-sm text-red-500">
            This will revoke access for the shared user. This action cannot be undone.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteDocumentModal;
